// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "org.uniswap",
    name: "Uniswap Wallet",
    homepage: "https://uniswap.org",
    image_id: "bff9cf1f-df19-42ce-f62a-87f04df13c00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/uniswap-wallet/id6443944476",
        android: "https://play.google.com/store/apps/details?id=com.uniswap.mobile",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "uniswap://",
        universal: "https://uniswap.org/app",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map